<template>
<div id="" class="">


  <v-card-title class="secondary white--text">
    <v-col cols="2">
      <v-icon dark>fa-film</v-icon>
    </v-col>
    <v-col cols="8" class="text-center">
      <h3>My Projects</h3>
    </v-col>
    <v-col cols="2" class="text-right">
      <v-btn icon dark @click="$eventBus.$emit('play_video',$store.state.app.tutorials.my_projects['General'])">
        <v-icon>fa-question</v-icon>
      </v-btn>
    </v-col>
  </v-card-title>

  <v-container fluid class="secondary lighten-1 white--text py-0">
    <v-row align="center" justify="center">

      <v-col cols="8" sm="8" md="4" lg="6" xl="8" class="order-3 order-sm-1 px-7 py-0">
        <v-checkbox color="primary" label="Contest Submissions" dark v-model="$store.state.user_projects.contest_only"></v-checkbox>
      </v-col>
      <v-spacer></v-spacer>
      <v-col cols="6" sm="4" md="4" lg="3" xl="2" class="order-1 order-sm-2">
        <v-select dark outlined label="Show" placeholder="All" :items="$store.state.user_projects.filter_options" clearable :value="$store.state.user_projects.filter" @change="$store.commit('user_projects/update_filter',$event)" hide-details>
        </v-select>
      </v-col>
      <v-col cols="6" sm="4" md="4" lg="3" xl="2" class="order-2 order-sm-2">
        <v-select dark outlined label="Sort by" placeholder="Featured" :items="$store.state.user_projects.sort_options" clearable :value="$store.state.user_projects.sort" @change="$store.commit('user_projects/update_sort',$event)" hide-details></v-select>
      </v-col>

    </v-row>
  </v-container>


  <v-container fluid>
    <v-row v-if="$store.getters['user_projects/list'].length">
      <v-col cols="12" sm="6" md="4" lg="3" xl="3" v-for="(project,i) in $store.getters['user_projects/list']" :key="i">
        <router-link class="nolink" :to="[11,12].includes(project.status) ? `/project/${project.id}/${project.slug}` :  `/user/projects/${project.id}` ">
          <v-card class="">
            <v-card-actions class="secondary white--text">
              <h5><v-icon class="mr-2" small :color="$store.getters['user_projects/statusColor'](project)" dark>fa-circle</v-icon> {{$store.getters['user_projects/statusLabel'](project)}}</h5>
              <v-spacer></v-spacer>
              <v-icon dark v-if="project.contest_id">fa-gift</v-icon>
            </v-card-actions>
            <v-img :aspect-ratio="16/9" :src="project.thumbnail_large">
            </v-img>
            <v-card-actions class="grey lighten-3">
              <div>
                <h5 v-if="project.title">{{project.title}}</h5>
                <h5 v-else>Unnamed project</h5>
              </div>
              <v-spacer>
              </v-spacer>
            </v-card-actions>
          </v-card>
        </router-link>
      </v-col>
    </v-row>
    <v-row v-else align="center" justify="center" style="height:300px">

      <div class="text-center">
        <v-btn to="/user/projects/create" fab dark x-large color="green" class="mb-2">
          <v-icon x-large>fa-plus</v-icon>
        </v-btn>
        <br />
        <h3>Start a new project</h3>
      </div>

    </v-row>
  </v-container>
</div>
</template>
<script>
export default {
  name: "",
  data: () => ({

  }),
  created() {
    this.$store.dispatch('user_projects/load')
  },
  methods: {

  }
}
</script>
<style lang="scss" scoped>
</style>
